
import { Switch } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
export const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: 'white',
        '&:hover': {
            backgroundColor: alpha('#34D399', theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#34D399',
    },
}));
export const PurpleSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: 'white',
        '&:hover': {
            backgroundColor: alpha('#820295', theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#820295',
    },
}));

export const ScrollTypography = {
    whiteSpace: 'nowrap',
    overflow: 'auto',
    "&::-webkit-scrollbar": {
        height: '2px'
    },
    "&::-webkit-scrollbar-track": {
        background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
    }
}

export const TextUnderlineHeading = {
    fontWeight: 'bold',
    textDecoration: 'underline',
    textDecorationThickness: '2px',
    textUnderlineOffset: '5px'
}

